<template>
  <div class="border rounded-md overflow-hidden">
    <div
      class="bg-blue-50 px-4 py-2 flex items-center justify-between uppercase font-bold text-xs text-neutral-700 cursor-pointer"
      @click="toggleCollapse"
      :class="{
        'cursor-not-allowed': !disabled,
        'border-b': expanded,
      }"
    >
      <h3>{{ header }}</h3>
      <Icon icon="bx:chevron-down" height="24" />
    </div>
    <div v-show="expanded" class="p-5">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "MobCollapse",
  components: {
    Icon,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.active,
    };
  },
  methods: {
    toggleCollapse() {
      if (!this.disabled) {
        this.expanded = !this.expanded;
      }
    },
  },
};
</script>
